import React, { useState, useEffect } from 'react';
import { DatePicker, Table, Card, Typography, Space, Input, messagen, Col,Row , Button} from 'antd';
import AxiosCaller from "../../../authenticatie/AxiosCaller";
import dayjs from "dayjs";
import { openNotificationSuccess, openNotificationError } from '../../../Components/Notification/Notification';
import PDFDownloader from '../../../Components/PDFDownloader/PDFDownloader';


const { Title, Text } = Typography;

const MFCScreen = () => {
  const { post, put } = AxiosCaller();
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [selectedDates, setSelectedDates] = useState([]);
  const [MFCData, setMFCData] = useState(null);
  const [filteredData, setFilteredData] = useState([]);
  const [expandedDate, setExpandedDate] = useState(null);
  const [editingCell, setEditingCell] = useState(null); // Track which cell is being edited
       const [maxHeight, setMaxHeight] = useState(0);
        
            useEffect(() => {
                const updateHeight = () => {
                    setMaxHeight(0.5 * document.documentElement.clientHeight);
                };
        
                updateHeight(); // Initialiseren bij eerste render
                window.addEventListener("resize", updateHeight); // Updaten bij schermresizing
        
                return () => window.removeEventListener("resize", updateHeight); // Cleanup
            }, []);

  // Fetch MFC data when month changes
  useEffect(() => {
    fetchMFC();
  }, [selectedMonth]);

  // Update table data when selectedDates change
  useEffect(() => {
    if (MFCData) {
  
      // Check which property exists and use it consistently
      const daysArray = MFCData.dagen || MFCData.data || [];
      
      if (selectedDates.length > 0) {
        const filtered = daysArray.filter(day =>
          selectedDates.includes(day.dag)
        );
       
        setFilteredData(filtered);
      } else {
        
        setFilteredData(daysArray);
      }
    }
  }, [selectedDates, MFCData]);

  const fetchMFC = async () => {
    if (!selectedMonth) {
      setMFCData(null);
      setFilteredData([])
      return;
    }
   
    try {
      const response = await post("/mfc", { maand: selectedMonth.format("YYYY-MM") });
     
      setMFCData(response.data);
    } catch (error) {
      console.error("Error fetching MFC data:", error);
      openNotificationError("Fout bij ophalen van de mfc", error)
    }
  };

  const handleMonthChange = (date) => {
    setSelectedMonth(date);
    setSelectedDates([]); // Reset selected dates when month changes
  };

  const postMFC = async () => {
    if (!MFCData) return;
    
    const daysArray = MFCData.dagen || MFCData.data || [];
    
    try {
      const response = await post("/mfc/opslaan", {
        maand: selectedMonth.format("MM-YYYY"), 
        dagen: daysArray 
      });
      openNotificationSuccess("MFC succesvol opgeslagen");
    } catch(error) {
      if(error.status == 409) {
        try {
         
          const response = await put("/mfc/"+error.response.data.id, MFCData);
          openNotificationSuccess("MFC succesvol bijgewerkt");
        } catch(error) {
          console.error(error);
          openNotificationError("Fout bij opslaan van het mfc", error);
        }
      } else {
        openNotificationError("Fout bij opslaan van het mfc", error);
      }
    }
  };

  const handleDateChange = (dates) => {
 
    const selected = dates ? dates.map(date => date.format("DD-MM-YYYY")) : [];
    setSelectedDates(selected);
  };

  const handleDateClick = (date) => {
    if (expandedDate === date) {
      setExpandedDate(null); // Close the table if the date is already expanded
    } else {
      setExpandedDate(date); // Show the table for the selected date
    }
  };

  // Function to handle editing MFC values
  const handleMfcValueChange = async (value, dayIndex, orderIndex, field) => {
    // Validate input is a number
    const numValue = parseInt(value, 10);
    if (isNaN(numValue)) {
      openNotificationError("Voer een geldig getal in");
      return;
    }

    // Update filtered data
    const updatedFilteredData = [...filteredData];
    const filteredDayIndex = updatedFilteredData.findIndex(day => day.dag === filteredData[dayIndex].dag);
    
    if (filteredDayIndex !== -1) {
      updatedFilteredData[filteredDayIndex].bestellingen[orderIndex].mfc[field] = numValue;
      setFilteredData(updatedFilteredData);
    }

    // Update original MFCData
    if (MFCData) {
      const updatedMFCData = { ...MFCData };
      const daysArray = updatedMFCData.dagen || updatedMFCData.data || [];
      const originalDayIndex = daysArray.findIndex(day => day.dag === filteredData[dayIndex].dag);
      
      if (originalDayIndex !== -1) {
        if (updatedMFCData.dagen) {
          updatedMFCData.dagen[originalDayIndex].bestellingen[orderIndex].mfc[field] = numValue;
        } else if (updatedMFCData.data) {
          updatedMFCData.data[originalDayIndex].bestellingen[orderIndex].mfc[field] = numValue;
        }
        setMFCData(updatedMFCData);
      }
    }

    // Exit editing mode
    setEditingCell(null);

    // Save changes
    await postMFC();
  };

  // Editable cell component
  const EditableCell = ({ dayIndex, orderIndex, field, value, isEditing }) => {
    return isEditing ? (
      <Input 
        autoFocus
        defaultValue={value}
        onPressEnter={(e) => handleMfcValueChange(e.target.value, dayIndex, orderIndex, field)}
        onBlur={(e) => handleMfcValueChange(e.target.value, dayIndex, orderIndex, field)}
      />
    ) : (
      <div 
        style={{ cursor: 'pointer', padding: '5px' }}
        onClick={() => setEditingCell({ dayIndex, orderIndex, field })}
      >
        {value}
      </div>
    );
  };

  // Custom render function for MFC columns
  const renderMfcCell = (value, record, index, dayIndex, field) => {
    const isEditing = 
      editingCell && 
      editingCell.dayIndex === dayIndex && 
      editingCell.orderIndex === index && 
      editingCell.field === field;
    
    return (
      <EditableCell
        dayIndex={dayIndex}
        orderIndex={index}
        field={field}
        value={value}
        isEditing={isEditing}
      />
    );
  };

  const getMfcPdf= async  () => {
    await PDFDownloader.generateMfcPDF(MFCData)
    await postMFC()
  }

  // Generate columns with the day index for editable cells
  const getColumns = (dayIndex) => [
    { title: "Klas", dataIndex: "klasNaam", key: "klasNaam" },
    {
      title: "Voorgerecht",
      dataIndex: "voorgerecht",
      key: "voorgerecht",
      render: (voorgerecht) =>
        voorgerecht.naam ? `${voorgerecht.naam} (${voorgerecht.aantal})` : "Geen",
    },
    {
      title: "Hoofdgerecht",
      dataIndex: "hoofdgerecht",
      key: "hoofdgerecht",
      render: (hoofdgerecht) =>
        hoofdgerecht.naam ? `${hoofdgerecht.naam} (${hoofdgerecht.aantal})` : "Geen",
    },
    {
      title: "Nagerecht",
      dataIndex: "nagerecht",
      key: "nagerecht",
      render: (nagerecht) =>
        nagerecht.naam ? `${nagerecht.naam} (${nagerecht.aantal})` : "Geen",
    },
    { 
      title: "MFC Voorgerecht", 
      dataIndex: ["mfc", "aantalVoorgerecht"], 
      key: "mfcVoorgerecht",
      render: (value, record, index) => renderMfcCell(value, record, index, dayIndex, "aantalVoorgerecht")
    },
    { 
      title: "MFC Hoofdgerecht", 
      dataIndex: ["mfc", "aantalHoofdgerecht"], 
      key: "mfcHoofdgerecht",
      render: (value, record, index) => renderMfcCell(value, record, index, dayIndex, "aantalHoofdgerecht")
    },
    { 
      title: "MFC Nagerecht", 
      dataIndex: ["mfc", "aantalNagerecht"], 
      key: "mfcNagerecht",
      render: (value, record, index) => renderMfcCell(value, record, index, dayIndex, "aantalNagerecht")
    },
  ];

  return (
    <div style={{ padding: "20px" }}>
      <div className='space-between'>
      <h1 className='title'>MFC Overzicht</h1>
      <Button type='primary' onClick={getMfcPdf} disabled={!selectedMonth}>pdf</Button>
      </div>

<Row gutter={16}>
  <Col span={12}>
    <Space direction="vertical" style={{ width: "100%" }}>
      
      <Text>Selecteer een maand:</Text>
      <DatePicker.MonthPicker
        onChange={handleMonthChange}
        value={selectedMonth}
        format="MM-YYYY"
        placeholder="Kies een maand"
        style={{ width: "100%" }}
      />
    </Space>
  </Col>
  
  <Col span={12}>
    {selectedMonth && MFCData && (
      <Space direction="vertical" style={{ width: "100%" }}>
        <Text>Selecteer meerdere datums:</Text>
        <DatePicker
          onChange={handleDateChange}
          value={selectedDates.map(date => dayjs(date))}
          format="DD-MM-YYYY"
          placeholder="Kies datums"
          disabledDate={(current) => {
            const daysArray = MFCData.dagen || MFCData.data || [];
            return !daysArray.some(day => day.dag === current.format("DD-MM-YYYY"));
          }}
          style={{ width: "100%" }}
          multiple
          maxTagCount="responsive"
        />
      </Space>
    )}
  </Col>
</Row>


      <div style={{ marginTop: "20px", overflowY: "auto", maxHeight }}>
        {filteredData.length > 0 ? (
          filteredData.map((day, dayIndex) => (
            <Card key={dayIndex} style={{ marginTop: "20px" }}>
              <Title
                level={4}
                style={{ cursor: "pointer" }}
                onClick={() => handleDateClick(day.dag)}
              >
                {dayjs(day.dag).format("DD-MM-YYYY")}
              </Title>

              {expandedDate === day.dag && (
                <Table
                  columns={getColumns(dayIndex)}
                  dataSource={day.bestellingen.map((order, idx) => ({
                    ...order,
                    key: idx,
                  }))}
                  pagination={false}
                  bordered
                />
              )}
            </Card>
          ))
        ) : (
          <Text>Geen data beschikbaar.</Text>
        )}
      </div>
    </div>
  );
};

export default MFCScreen;